import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ControlWidgetService, EveReportingControlWidgetWidget } from '../../../../services/ControlWidgetService.service';
import { EveReportingWidget, EveReportingWidgetType } from '../../widget.component';




@Component({
  selector: 'text-input-control-widget',
  templateUrl: 'text-input-control-widget.component.html',
  styleUrls: ['./text-input-control-widget.component.css']
})
export class TextInputControlWidgetComponent implements OnInit, OnDestroy {

  @Input()
  widget?: EveReportingControlWidgetWidget = null;

  widgetTypes = EveReportingWidgetType;

  controlValue: BehaviorSubject<string> = new BehaviorSubject<string>("");

  constructor(
    public controlWidgetService: ControlWidgetService,
  ) {


  }
    

  ngOnInit(): void {

    if (this.widget != null && this.widget.controlWidgetId == null) this.widget.controlWidgetId = crypto.randomUUID();

    this.controlWidgetService.addControlWidget(this);


  }

  ngOnDestroy(): void {
    this.controlWidgetService.removeControlWidget(this);
  }

  
}



